window.DppProductPro = function (UID, CFG) {
  var ROOT_ID = 'dpp-' + UID;
  function money(cents) {
    var amount = (cents / 100).toFixed(2);
    return CFG.moneyFormat.replace(/\{\{\s*[a-z_]+\s*\}\}/g, amount);
  }

  function init() {
    var root = document.getElementById(ROOT_ID);
    if (!root || root.dataset.dppReady === '1') return;
    root.dataset.dppReady = '1';

    var variants = [];
    try {
      var tag = document.querySelector('[data-dpp-variants-' + UID + ']');
      variants = JSON.parse(tag.textContent);
    } catch (err) { variants = []; }

    var exactWeights = {};
    try {
      var ewTag = document.querySelector('[data-dpp-exact-weights-' + UID + ']');
      exactWeights = JSON.parse(ewTag.textContent) || {};
    } catch (err) { exactWeights = {}; }

    /* Each variant can own one photo. Matching a thumbnail back to whichever
       variant claims it is what lets clicking a photo act like picking that
       exact disc, not just enlarging a picture of it. */
    var variantByMediaId = {};
    variants.forEach(function (v) {
      if (v.featured_media && v.featured_media.id) variantByMediaId[v.featured_media.id] = v;
    });

    /* A copy taken before the positional pairing below, so the sold marker can
       be limited to photos a variant really owns in Shopify if the loose
       pairing ever mislabels something. */
    var directVariantByMediaId = {};
    Object.keys(variantByMediaId).forEach(function (k) {
      directVariantByMediaId[k] = variantByMediaId[k];
    });

    /* Shopify only lets a variant officially claim one photo, so a second
       shot of the same disc (a back view) can never be assigned to it
       directly, no matter how the product is set up. Instead it's placed
       immediately after its front photo in the product's own media order,
       and left unassigned. Walking the thumbnails in that same order and
       handing an unclaimed photo to whichever variant's photo comes right
       before it is what lets clicking the back shot still select the right
       disc. A variant with no such photo, or one already claimed by
       something else, is simply left alone here, nothing forces a match. */
    var thumbOrderForPairing = Array.prototype.slice.call(root.querySelectorAll('[data-dpp-thumb]'));
    thumbOrderForPairing.forEach(function (btn, i) {
      var owner = variantByMediaId[btn.dataset.mediaId];
      if (!owner) return;
      var next = thumbOrderForPairing[i + 1];
      if (!next) return;
      var nextId = next.dataset.mediaId;
      if (nextId && !variantByMediaId[nextId]) variantByMediaId[nextId] = owner;
    });

    /* ---------- sold marker on the thumbnails ----------
       A photo is marked only when a variant claims it AND that variant is out
       of stock. Anything unclaimed, a lifestyle shot or a photo nobody owns,
       is left blank rather than inheriting the disc above it.

       Two safeguards, because the pairing above is positional:
         1. If any variant has no photo assigned to it in Shopify, positional
            pairing cannot tell whose photo an unassigned one is, so a sold
            disc's state could bleed onto the next disc's front shot. In that
            case the marker falls back to photos a variant directly owns.
         2. The strict setting forces that same direct-only behavior on demand.
       Either way a sold disc with no assigned photo simply goes unmarked,
       which is the safe direction to fail. */
    var thumbsWrap = root.querySelector('[data-dpp-thumbs]');
    var everyVariantOwnsAPhoto = variants.length > 0 && variants.every(function (v) {
      return !!(v.featured_media && v.featured_media.id);
    });

    /* ---------- group front/back thumbnails so they read as one button ----------
       Same one-hop rule as the sold-badge chain below: a photo Shopify actually
       assigned to a variant, immediately followed by a photo nobody owns, is a
       front/back pair. Wrapping the two buttons together - rather than trying to
       fake it with per-thumbnail margins - is what lets the pair sit flush
       against each other while every other thumbnail keeps the normal gap, and
       it costs nothing when a disc only has one photo: nothing gets wrapped. */
    function groupThumbPairs() {
      if (!thumbsWrap) return;
      for (var i = 0; i < thumbOrderForPairing.length - 1; i++) {
        var front = thumbOrderForPairing[i];
        var back = thumbOrderForPairing[i + 1];
        if (!directVariantByMediaId[front.dataset.mediaId]) continue;
        if (directVariantByMediaId[back.dataset.mediaId]) continue;
        if (front.parentNode && front.parentNode.classList.contains('dpp-thumb-pair')) continue;
        var pair = document.createElement('div');
        pair.className = 'dpp-thumb-pair';
        front.parentNode.insertBefore(pair, front);
        front.classList.add('dpp-thumb--half');
        back.classList.add('dpp-thumb--half');
        pair.appendChild(front);
        pair.appendChild(back);
      }
    }
    groupThumbPairs();

    /* The pairing above is deliberately greedy: every unclaimed photo up to the
       next disc's photo selects the disc before it, which is what makes any
       angle of a disc clickable. For the marker that is too loose, because
       stray photos at the end of the product would inherit whatever the last
       disc's state was. So the marker chains exactly one photo past a photo a
       variant really owns, which is the front/back pair and nothing more. */
    var badgeVariantByMediaId = {};
    Object.keys(directVariantByMediaId).forEach(function (k) {
      badgeVariantByMediaId[k] = directVariantByMediaId[k];
    });
    thumbOrderForPairing.forEach(function (btn, i) {
      var owner = directVariantByMediaId[btn.dataset.mediaId];
      if (!owner) return;
      var next = thumbOrderForPairing[i + 1];
      if (!next) return;
      var nextId = next.dataset.mediaId;
      if (nextId && !badgeVariantByMediaId[nextId]) badgeVariantByMediaId[nextId] = owner;
    });

    function markSoldThumbs() {
      if (!thumbsWrap || thumbsWrap.dataset.soldBadge !== '1') return;
      var strict = thumbsWrap.dataset.soldStrict === '1' || !everyVariantOwnsAPhoto;
      var map = strict ? directVariantByMediaId : badgeVariantByMediaId;
      var label = thumbsWrap.dataset.soldLabel || 'Sold';
      /* A product with one disc in it owns every photo on the page, assigned or
         not, so there is nothing to trace and no way to mislabel. */
      var onlyVariant = variants.length === 1 ? variants[0] : null;
      thumbOrderForPairing.forEach(function (btn) {
        var owner = onlyVariant || map[btn.dataset.mediaId];
        var sold = !!(owner && owner.available === false);
        btn.classList.toggle('is-sold', sold);
        var tag = btn.querySelector('[data-dpp-thumb-sold]');
        if (tag) tag.hidden = !sold;
        var base = btn.dataset.baseLabel || btn.getAttribute('aria-label') || '';
        btn.setAttribute('aria-label', sold ? base + ', ' + label : base);
      });
    }

    /* ---------- sold or sale badge over the main photo ---------- */
    var stageBadge = root.querySelector('[data-dpp-stage-badge]');

    function paintStageBadge(v) {
      if (!stageBadge || stageBadge.dataset.follows !== '1') return;
      var text = '';
      if (v) {
        if (v.available === false) text = stageBadge.dataset.soldText || '';
        else if (v.compare_at_price && v.compare_at_price > v.price) text = stageBadge.dataset.saleText || '';
      }
      stageBadge.textContent = text;
      stageBadge.hidden = text === '';
    }

    markSoldThumbs();

    var form = root.querySelector('[data-dpp-form]');
    var idInput = root.querySelector('[data-dpp-variant]');
    var addBtn = root.querySelector('[data-dpp-add]');

    /* ---------- flight path engine ---------- */
    root.querySelectorAll('[data-dpp-fp]').forEach(function (fp) {
      if (fp.dataset.fpReady === '1') return;
      fp.dataset.fpReady = '1';
      var line = fp.querySelector('.dpp-fp-line');
      var disc = fp.querySelector('[data-dpp-fp-disc]');
      if (!line || !disc) return;
      var trackTick = fp.querySelector('[data-dpp-fp-tracktick]');
      var trackText = fp.querySelector('[data-dpp-fp-tracktext]');
      var L = 0;
      try { L = line.getTotalLength(); } catch (err) { L = 0; }
      var dur = parseInt(fp.getAttribute('data-dur'), 10) || 2600;
      var dist = parseInt(fp.getAttribute('data-dist'), 10) || 0;
      var distEl = fp.querySelector('[data-dpp-fp-dist]');
      var steps = fp.querySelectorAll('[data-dpp-fp-step]');
      var turnText = fp.querySelector('[data-dpp-fp-turntext]');
      var fadeText = fp.querySelector('[data-dpp-fp-fadetext]');
      var raf = null, played = false;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function setStep(i, on) { if (steps[i]) steps[i].classList.toggle('dpp-is-on', on); }
      function moveDisc(t) {
        if (!L) return;
        var p = line.getPointAtLength(L * t);
        disc.setAttribute('transform', 'translate(' + p.x + ',' + p.y + ')');
        if (trackTick) { trackTick.setAttribute('y1', p.y); trackTick.setAttribute('y2', p.y); }
        if (trackText) { trackText.setAttribute('y', p.y); }
      }
      function reset() {
        if (raf) cancelAnimationFrame(raf);
        moveDisc(0);
        disc.style.opacity = '1';
        disc.classList.remove('dpp-flying');
        if (L) {
          line.style.strokeDasharray = L + ' ' + L;
          line.style.strokeDashoffset = L;
        }
        steps.forEach(function (s) { s.classList.remove('dpp-is-on'); });
        if (distEl) distEl.textContent = '~0 ft';
        if (trackText) trackText.textContent = '0 ft';
      }
      function staticEnd() {
        moveDisc(1);
        disc.style.opacity = '1';
        if (L) { line.style.strokeDasharray = 'none'; line.style.strokeDashoffset = 0; }
        setStep(0, true); setStep(1, true); setStep(2, true);
        if (distEl) distEl.textContent = '~' + dist + ' ft';
        if (trackText) trackText.textContent = dist + ' ft';
      }
      function easeOut(t) { return 1 - Math.pow(1 - t, 2.2); }
      function throwIt() {
        played = true;
        if (raf) { cancelAnimationFrame(raf); raf = null; }
        if (reduce || !L) { staticEnd(); return; }
        reset();
        disc.style.opacity = '1';
        disc.classList.add('dpp-flying');
        if (L) { line.style.strokeDasharray = L + ' ' + L; }
        var start = performance.now();
        function frame(now) {
          var t = Math.min(1, (now - start) / dur);
          var e = easeOut(t);
          moveDisc(e);
          if (L) line.style.strokeDashoffset = L * (1 - e);
          if (distEl) distEl.textContent = '~' + Math.round(dist * e) + ' ft';
          if (trackText) trackText.textContent = Math.round(dist * e) + ' ft';
          setStep(0, true);
          setStep(1, e > 0.42);
          setStep(2, e > 0.78);
          if (t < 1) { raf = requestAnimationFrame(frame); }
          else {
            raf = null;
            disc.classList.remove('dpp-flying');
            setStep(2, true);
            if (distEl) distEl.textContent = '~' + dist + ' ft';
            if (trackText) trackText.textContent = dist + ' ft';
          }
        }
        raf = requestAnimationFrame(frame);
      }
      var dirBtns = fp.querySelectorAll('[data-dpp-fp-dir]');
      function applyDir(lefty) {
        fp.classList.toggle('dpp-fp--left', lefty);
        var note = fp.querySelector('[data-dpp-fp-note]');
        if (note) note.textContent = (fp.getAttribute(lefty ? 'data-note-l' : 'data-note-r') || '').replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#39;/g, "'");
        if (turnText) turnText.textContent = fp.getAttribute(lefty ? 'data-turn-l' : 'data-turn-r') || '';
        if (fadeText) fadeText.textContent = fp.getAttribute(lefty ? 'data-fade-l' : 'data-fade-r') || '';
      }
      dirBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          dirBtns.forEach(function (b) { b.classList.toggle('dpp-is-active', b === btn); });
          applyDir(btn.getAttribute('data-dpp-fp-dir') === 'lhbh');
          if (played) throwIt();
        });
      });
      var replayBtn = fp.querySelector('[data-dpp-fp-replay]');
      if (replayBtn) replayBtn.addEventListener('click', throwIt);
      if (reduce || !L) { staticEnd(); return; }
      reset();
      if (fp.classList.contains('dpp-path--anim') && 'IntersectionObserver' in window) {
        var fio = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { throwIt(); fio.disconnect(); }
          });
        }, { threshold: 0.35 });
        fio.observe(fp);
      } else {
        staticEnd();
      }
    });

    /* ---------- scroll reveal ---------- */
    if (CFG.reveal) {
      var rvTargets = root.querySelectorAll('.dpp-buy-in > *, .dpp-gbelow > *');
      rvTargets.forEach(function (el) { el.classList.add('dpp-rv'); });
      var revealOne = function (el) {
        el.classList.add('dpp-is-revealed');
        rvo.unobserve(el);
      };
      var rvo = null;
      if ('IntersectionObserver' in window) {
        rvo = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) revealOne(en.target); });
        }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });
        root.querySelectorAll('.dpp-rv').forEach(function (el) { rvo.observe(el); });
      } else {
        rvTargets.forEach(function (el) { el.classList.add('dpp-is-revealed'); });
      }
    }

    var buyNow = root.querySelector('[data-dpp-buynow]');
    var priceEl = root.querySelector('[data-dpp-price-current]');
    var wasEl = root.querySelector('[data-dpp-price-was]');
    var saveEl = root.querySelector('[data-dpp-save]');
    var stockText = root.querySelector('[data-dpp-stocktext]');
    var stockDot = root.querySelector('[data-dpp-dot]');
    var skuEl = root.querySelector('[data-dpp-sku]');
    var mainImg = root.querySelector('[data-dpp-main]');
    var stage = root.querySelector('[data-dpp-stage]');
    var sticky = document.getElementById('dpp-sticky-' + UID);
    var stickyPrice = sticky ? sticky.querySelector('[data-dpp-sticky-price]') : null;
    var stickyAdd = sticky ? sticky.querySelector('[data-dpp-sticky-add]') : null;

    /* ---------- gallery ---------- */
    root.querySelectorAll('[data-dpp-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!mainImg) return;

        var owner = variantByMediaId[btn.dataset.mediaId];
        if (owner) selectVariant(owner);

        /* selectVariant() always ends by showing whichever one photo the
           variant officially owns, since that's the only one Shopify lets
           it claim. When the photo just clicked is a second, unassigned
           shot riding along next to it (a back view), it needs to win here,
           last, or the page would flash to the back photo for an instant
           and then silently snap back to the front one. */
        mainImg.src = btn.dataset.src;
        mainImg.removeAttribute('srcset');
        mainImg.alt = btn.dataset.alt || '';
        root.querySelectorAll('[data-dpp-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', b === btn ? 'true' : 'false');
        });
      });
    });

    /* ================= ZOOM ================= */
    (function () {
      if (!stage || !mainImg) return;

      var Z = CFG.zoom;
      var layer = stage.querySelector('[data-dpp-zoomlayer]');
      var lens = stage.querySelector('[data-dpp-lens]');
      var cue = stage.querySelector('[data-dpp-cue]');
      var lb = document.getElementById('dpp-lb-' + UID);
      var coarse = window.matchMedia('(pointer: coarse)').matches;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var mode = coarse ? Z.mobile : Z.desktop;

      var hiCache = {};
      function hiSrc() { return mainImg.dataset.zoom || mainImg.currentSrc || mainImg.src; }
      function loadHi() {
        var url = hiSrc();
        if (hiCache[url]) return hiCache[url];
        hiCache[url] = new Promise(function (resolve, reject) {
          var im = new Image();
          im.decoding = 'async';
          im.onload = function () {
            if (im.decode) { im.decode().then(function () { resolve(im); }).catch(function () { resolve(im); }); }
            else { resolve(im); }
          };
          im.onerror = reject;
          im.src = url;
        });
        return hiCache[url];
      }

      function panOn() {
        if (!layer) return;
        loadHi().then(function (im) {
          layer.style.backgroundImage = 'url("' + im.src + '")';
          layer.style.backgroundSize = (Z.level) + '% auto';
          stage.classList.add('is-panning');
        }).catch(function () {});
      }
      function panMove(e) {
        if (!layer) return;
        var r = stage.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        x = Math.max(0, Math.min(100, x));
        y = Math.max(0, Math.min(100, y));
        layer.style.backgroundPosition = x + '% ' + y + '%';
      }
      function panOff() { stage.classList.remove('is-panning'); }

      function lensOn() {
        if (!lens) return;
        loadHi().then(function (im) {
          var r = stage.getBoundingClientRect();
          lens.style.backgroundImage = 'url("' + im.src + '")';
          lens.style.backgroundSize = (r.width * Z.level / 100) + 'px ' + (r.height * Z.level / 100) + 'px';
          stage.classList.add('is-lensing');
        }).catch(function () {});
      }
      function lensMove(e) {
        if (!lens) return;
        var r = stage.getBoundingClientRect();
        var x = e.clientX - r.left;
        var y = e.clientY - r.top;
        if (x < 0 || y < 0 || x > r.width || y > r.height) { lensOff(); return; }
        lens.style.left = x + 'px';
        lens.style.top = y + 'px';
        var k = Z.level / 100;
        var bx = -(x * k - Z.lens / 2);
        var by = -(y * k - Z.lens / 2);
        lens.style.backgroundPosition = bx + 'px ' + by + 'px';
      }
      function lensOff() { stage.classList.remove('is-lensing'); }

      /* ---- lightbox ---- */
      var lbImg = lb ? lb.querySelector('[data-dpp-lb-img]') : null;
      var lbCount = lb ? lb.querySelector('[data-dpp-lb-count]') : null;
      var lbThumbs = lb ? Array.prototype.slice.call(lb.querySelectorAll('[data-dpp-lb-thumb]')) : [];
      var lbScale = 1, lbX = 0, lbY = 0, lastFocus = null;
      var thumbBtns = Array.prototype.slice.call(root.querySelectorAll('[data-dpp-thumb]'));
      var lbIndex = 0;

      function lbApply() {
        if (!lbImg) return;
        lbImg.style.transform = 'translate(' + lbX + 'px,' + lbY + 'px) scale(' + lbScale + ')';
      }
      function lbSetScale(next, cx, cy) {
        var prev = lbScale;
        lbScale = Math.max(1, Math.min(Z.lbMax / 100, next));
        if (lbScale === 1) { lbX = 0; lbY = 0; }
        else if (cx !== undefined && lbImg) {
          var r = lbImg.getBoundingClientRect();
          var ox = cx - (r.left + r.width / 2);
          var oy = cy - (r.top + r.height / 2);
          var k = lbScale / prev;
          lbX = lbX - ox * (k - 1);
          lbY = lbY - oy * (k - 1);
        }
        lbApply();
      }
      function lbShow(i) {
        if (!lb || !lbImg) return;
        var src = '', alt = '';
        if (thumbBtns.length) {
          lbIndex = (i + thumbBtns.length) % thumbBtns.length;
          src = thumbBtns[lbIndex].dataset.zoom || thumbBtns[lbIndex].dataset.full;
          alt = thumbBtns[lbIndex].dataset.alt || '';
        } else {
          src = hiSrc();
          alt = mainImg.alt || '';
        }
        lbImg.src = src;
        lbImg.alt = alt;
        lbImg.removeAttribute('width');
        lbImg.removeAttribute('height');
        lbScale = 1; lbX = 0; lbY = 0; lbApply();
        if (lbCount) lbCount.textContent = (lbIndex + 1) + ' / ' + (thumbBtns.length || 1);
        lbThumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === lbIndex ? 'true' : 'false'); });
      }
      function lbOpen(i) {
        if (!lb) return;
        lastFocus = document.activeElement;
        lb.hidden = false;
        lb.classList.add('is-open');
        requestAnimationFrame(function () { lb.classList.add('is-visible'); });
        document.documentElement.style.overflow = 'hidden';
        lbShow(i === undefined ? currentIndex() : i);
        var closeBtn = lb.querySelector('[data-dpp-lb-close]');
        if (closeBtn) closeBtn.focus();
      }
      function lbClose() {
        if (!lb) return;
        lb.classList.remove('is-visible');
        document.documentElement.style.overflow = '';
        setTimeout(function () {
          lb.classList.remove('is-open');
          lb.hidden = true;
        }, 200);
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      function currentIndex() {
        var found = 0;
        thumbBtns.forEach(function (b, n) {
          if (b.getAttribute('aria-current') === 'true') found = n;
        });
        return found;
      }

      if (lb) {
        var closeB = lb.querySelector('[data-dpp-lb-close]');
        if (closeB) closeB.addEventListener('click', lbClose);
        var prevB = lb.querySelector('[data-dpp-lb-prev]');
        var nextB = lb.querySelector('[data-dpp-lb-next]');
        if (prevB) prevB.addEventListener('click', function () { lbShow(lbIndex - 1); });
        if (nextB) nextB.addEventListener('click', function () { lbShow(lbIndex + 1); });
        var inB = lb.querySelector('[data-dpp-lb-in]');
        var outB = lb.querySelector('[data-dpp-lb-out]');
        if (inB) inB.addEventListener('click', function () { lbSetScale(lbScale + Z.lbStep / 100); });
        if (outB) outB.addEventListener('click', function () { lbSetScale(lbScale - Z.lbStep / 100); });
        lbThumbs.forEach(function (t) {
          t.addEventListener('click', function () { lbShow(parseInt(t.dataset.index, 10)); });
        });

        lb.addEventListener('click', function (e) {
          if (lb.dataset.panned === '1') { lb.dataset.panned = ''; return; }
          if (e.target === lb || e.target.hasAttribute('data-dpp-lb-stage')) lbClose();
        });
        document.addEventListener('keydown', function (e) {
          if (lb.hidden) return;
          if (e.key === 'Escape') lbClose();
          if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
          if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
          if (e.key === '+' || e.key === '=') lbSetScale(lbScale + Z.lbStep / 100);
          if (e.key === '-') lbSetScale(lbScale - Z.lbStep / 100);
        });

        if (Z.lbWheel && lbImg) {
          lb.addEventListener('wheel', function (e) {
            e.preventDefault();
            lbSetScale(lbScale + (e.deltaY < 0 ? 0.2 : -0.2), e.clientX, e.clientY);
          }, { passive: false });
        }

        if (lbImg) {
          var pts = {}, startDist = 0, startScale = 1, dragFrom = null, moved = false;

          lbImg.addEventListener('dragstart', function (e) { e.preventDefault(); });
          lbImg.addEventListener('pointerdown', function (e) {
            pts[e.pointerId] = { x: e.clientX, y: e.clientY };
            lbImg.setPointerCapture(e.pointerId);
            var ids = Object.keys(pts);
            if (ids.length === 2) {
              var a = pts[ids[0]], b = pts[ids[1]];
              startDist = Math.hypot(a.x - b.x, a.y - b.y);
              startScale = lbScale;
            } else if (lbScale > 1) {
              dragFrom = { x: e.clientX - lbX, y: e.clientY - lbY };
              lb.classList.add('is-dragging');
            }
          });
          lbImg.addEventListener('pointermove', function (e) {
            if (!pts[e.pointerId]) return;
            pts[e.pointerId] = { x: e.clientX, y: e.clientY };
            var ids = Object.keys(pts);
            if (ids.length === 2 && startDist > 0) {
              var a = pts[ids[0]], b = pts[ids[1]];
              var d = Math.hypot(a.x - b.x, a.y - b.y);
              lbSetScale(startScale * (d / startDist));
            } else if (dragFrom) {
              lbX = e.clientX - dragFrom.x;
              lbY = e.clientY - dragFrom.y;
              moved = true;
              lbApply();
            }
          });
          function endPointer(e) {
            delete pts[e.pointerId];
            if (Object.keys(pts).length < 2) startDist = 0;
            dragFrom = null;
            if (moved) { lb.dataset.panned = '1'; moved = false; }
            lb.classList.remove('is-dragging');
          }
          lbImg.addEventListener('pointerup', endPointer);
          lbImg.addEventListener('pointercancel', endPointer);

          var lastTap = 0;
          lbImg.addEventListener('click', function (e) {
            var now = Date.now();
            if (now - lastTap < 320) {
              lbSetScale(lbScale > 1 ? 1 : Z.lbDouble / 100, e.clientX, e.clientY);
            }
            lastTap = now;
          });
        }
      }

      /* ---- inline pinch on the stage itself ---- */
      function enableInlinePinch() {
        var pts = {}, d0 = 0, s0 = 1, sc = 1, tx = 0, ty = 0, from = null;
        function apply() {
          mainImg.style.transformOrigin = 'center center';
          mainImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + sc + ')';
          stage.classList.toggle('is-pinching', sc > 1);
        }
        stage.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'touch') return;
          pts[e.pointerId] = { x: e.clientX, y: e.clientY };
          var ids = Object.keys(pts);
          if (ids.length === 2) {
            var a = pts[ids[0]], b = pts[ids[1]];
            d0 = Math.hypot(a.x - b.x, a.y - b.y);
            s0 = sc;
          } else if (sc > 1) {
            from = { x: e.clientX - tx, y: e.clientY - ty };
          }
        });
        stage.addEventListener('pointermove', function (e) {
          if (!pts[e.pointerId]) return;
          pts[e.pointerId] = { x: e.clientX, y: e.clientY };
          var ids = Object.keys(pts);
          if (ids.length === 2 && d0 > 0) {
            var a = pts[ids[0]], b = pts[ids[1]];
            sc = Math.max(1, Math.min(Z.level / 100, s0 * (Math.hypot(a.x - b.x, a.y - b.y) / d0)));
            if (sc === 1) { tx = 0; ty = 0; }
            apply();
          } else if (from && sc > 1) {
            tx = e.clientX - from.x;
            ty = e.clientY - from.y;
            apply();
          }
        });
        function up(e) {
          delete pts[e.pointerId];
          if (Object.keys(pts).length < 2) d0 = 0;
          from = null;
          if (sc <= 1.02) { sc = 1; tx = 0; ty = 0; apply(); }
        }
        stage.addEventListener('pointerup', up);
        stage.addEventListener('pointercancel', up);

        var last = 0;
        stage.addEventListener('click', function () {
          var now = Date.now();
          if (now - last < 320) {
            sc = sc > 1 ? 1 : Z.level / 100;
            tx = 0; ty = 0;
            apply();
          }
          last = now;
        });
      }

      var opensLightbox = mode.indexOf('lightbox') !== -1;

      if (!coarse && !reduce) {
        if (mode === 'scale') {
          stage.classList.add('z-scale');
        } else if (mode === 'pan' || mode === 'pan_lightbox') {
          stage.addEventListener('pointerenter', panOn);
          stage.addEventListener('pointermove', panMove);
          stage.addEventListener('pointerleave', panOff);
        } else if (mode === 'lens' || mode === 'lens_lightbox') {
          stage.addEventListener('pointerenter', lensOn);
          stage.addEventListener('pointermove', lensMove);
          stage.addEventListener('pointerleave', lensOff);
        }
      } else if (coarse) {
        if (mode === 'pinch' || mode === 'pinch_lightbox') enableInlinePinch();
      }

      if (opensLightbox && lb) {
        stage.classList.add('is-clickable');
        stage.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('[data-dpp-cue]')) return;
          panOff(); lensOff();
          lbOpen();
        });
        stage.setAttribute('role', 'button');
        stage.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); lbOpen(); }
        });
      }

      if (cue) {
        cue.addEventListener('click', function (e) {
          e.stopPropagation();
          if (lb) lbOpen();
        });
      }

      thumbBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.dataset.zoom) mainImg.dataset.zoom = btn.dataset.zoom;
          panOff(); lensOff();
          mainImg.style.transform = '';
          stage.classList.remove('is-pinching');
        });
      });
    })();

    /* ---------- quantity ---------- */
    var qty = root.querySelector('[data-dpp-qty]');
    var minus = root.querySelector('[data-dpp-minus]');
    var plus = root.querySelector('[data-dpp-plus]');
    var qtyNote = root.querySelector('[data-dpp-qtynote]');
    var qtyWrap = root.querySelector('[data-dpp-qtywrap]');
    var errEl = root.querySelector('[data-dpp-error]');
    var inCart = {};
    var cartLoaded = false;

    var stock = {};
    try {
      var invNode = document.querySelector('[data-dpp-inventory-' + UID + ']');
      if (invNode) stock = JSON.parse(invNode.textContent);
    } catch (e) { stock = {}; }

    function stockCap(v) {
      if (!v) return Infinity;
      var row = stock[v.id] || stock[String(v.id)];
      if (!row) return Infinity;
      if (!row.tracked) return Infinity;
      if (row.policy !== 'deny') return Infinity;
      var n = typeof row.qty === 'number' ? row.qty : 0;
      return n > 0 ? n : 0;
    }
    function remainingFor(v) {
      var cap = stockCap(v);
      if (cap === Infinity) return Infinity;
      var held = inCart[v.id] || 0;
      return Math.max(0, cap - held);
    }

    function showError(msg) {
      if (!errEl) return;
      if (!msg) { errEl.hidden = true; errEl.textContent = ''; return; }
      errEl.textContent = msg;
      errEl.hidden = false;
    }

    function applyButtonState(v) {
      if (!v) return;
      var soldOut = !v.available;
      var left = remainingFor(v);
      var label, off;

      if (soldOut) {
        label = CFG.soldOut; off = true;
      } else if (left === 0) {
        label = CFG.inBagLabel; off = true;
      } else {
        label = CFG.ctaLabel; off = false;
      }

      if (addBtn) { addBtn.disabled = off; addBtn.textContent = label; }
      if (buyNow) buyNow.disabled = off;
      if (stickyAdd) {
        stickyAdd.disabled = off;
        stickyAdd.textContent = (off || !CFG.stickyLabel) ? label : CFG.stickyLabel;
      }
    }

    function refreshLimits() {
      var v = findVariant() || variants[0];
      if (!v) return;
      var left = remainingFor(v);

      if (qty) {
        if (left === Infinity) {
          qty.removeAttribute('max');
        } else {
          qty.max = Math.max(1, left);
          if ((parseInt(qty.value, 10) || 1) > left) qty.value = Math.max(1, left);
        }
      }
      if (plus) plus.disabled = left !== Infinity && (parseInt(qty ? qty.value : 1, 10) || 1) >= left;

      if (qtyWrap && CFG.hideQtySingle && left === 1) qtyWrap.hidden = true;
      else if (qtyWrap && CFG.hideQtySingle) qtyWrap.hidden = false;

      if (qtyNote) {
        if (CFG.showQtyNote && left !== Infinity && left > 0 && CFG.qtyNote) {
          qtyNote.textContent = String(CFG.qtyNote).split('[max]').join(left);
          qtyNote.hidden = false;
        } else {
          qtyNote.hidden = true;
        }
      }

      applyButtonState(v);
    }

    function watchCart() {
      var pending = null;
      function recheck() {
        clearTimeout(pending);
        pending = setTimeout(function () {
          showError('');
          applyButtonState(findVariant() || variants[0]);
          loadCart();
        }, 250);
      }

      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) recheck();
      });
      window.addEventListener('pageshow', function (e) { if (e.persisted) recheck(); });
      window.addEventListener('focus', recheck);

      ['cart:refresh', 'cart:updated', 'cart:change', 'cart-drawer:updated', 'cart:build']
        .forEach(function (name) {
          document.addEventListener(name, function (e) {
            if (e && e.detail && e.detail.dppSelf) return;
            recheck();
          });
        });

      if ('MutationObserver' in window) {
        discoverCartSections().forEach(function (id) {
          var el = document.getElementById('shopify-section-' + id);
          if (!el) return;
          new MutationObserver(recheck).observe(el, { childList: true, subtree: true });
        });
      }
    }

    function loadCart() {
      if (!CFG.respectCart) { cartLoaded = true; refreshLimits(); return; }
      fetch((CFG.cartUrl || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          inCart = {};
          (cart.items || []).forEach(function (li) { inCart[li.variant_id] = li.quantity; });
          cartLoaded = true;
          refreshLimits();
        })
        .catch(function () { cartLoaded = true; refreshLimits(); });
    }

    function step(n) {
      if (!qty) return;
      var v = parseInt(qty.value, 10) || 1;
      var cap = remainingFor(findVariant() || variants[0]);
      v = Math.max(1, v + n);
      if (cap !== Infinity) v = Math.min(v, Math.max(1, cap));
      qty.value = v;
      showError('');
      refreshLimits();
    }
    if (minus) minus.addEventListener('click', function () { step(-1); });
    if (plus) plus.addEventListener('click', function () { step(1); });
    if (qty) {
      qty.addEventListener('change', function () {
        var cap = remainingFor(findVariant() || variants[0]);
        var v = Math.max(1, parseInt(qty.value, 10) || 1);
        if (cap !== Infinity) v = Math.min(v, Math.max(1, cap));
        qty.value = v;
        refreshLimits();
      });
    }

    /* ---------- keeping the header honest ---------- */
    function discoverCartSections() {
      var ids = [];
      document.querySelectorAll('[id^="shopify-section-"]').forEach(function (el) {
        var id = el.id.replace('shopify-section-', '');
        if (/cart|header/i.test(id) && ids.indexOf(id) === -1) ids.push(id);
      });
      return ids;
    }

    var BAG_SELECTORS = [
      '[data-dpp-cart-target]',
      'cart-icon',
      '[data-testid="cart-icon"]',
      '#cart-icon-bubble',
      '.header__icon--cart',
      '#CartDrawer-Icon',
      '[class*="cart-icon"]',
      '[class*="cart__icon"]',
      '[aria-label*="cart" i]',
      '[aria-label*="bag" i]',
      '[href$="/cart"]',
      '[href*="/cart"]'
    ];

    function bagIn(scope) {
      for (var i = 0; i < BAG_SELECTORS.length; i++) {
        var el;
        try { el = scope.querySelector(BAG_SELECTORS[i]); } catch (e) { el = null; }
        if (el) return el;
      }
      return null;
    }

    function syncNativeBag(sections) {
      if (!sections) return false;
      var live = findBag();
      if (!live) return false;
      var keys = Object.keys(sections);
      for (var i = 0; i < keys.length; i++) {
        var html = sections[keys[i]];
        if (!html) continue;
        var doc;
        try { doc = new DOMParser().parseFromString(html, 'text/html'); } catch (e) { continue; }
        var fresh = bagIn(doc);
        if (fresh && fresh.innerHTML.trim()) {
          live.innerHTML = fresh.innerHTML;
          var mine = document.getElementById('dpp-bagcount-' + UID);
          if (mine) mine.remove();
          return true;
        }
      }
      return false;
    }

    function ensureBadge(n) {
      if (!CFG.makeBadge) return;
      var bag = findBag();
      if (!bag) return;
      var badge = document.getElementById('dpp-bagcount-' + UID);
      if (!badge) {
        badge = document.createElement('span');
        badge.id = 'dpp-bagcount-' + UID;
        badge.className = 'dpp-bagcount';
        badge.setAttribute('aria-hidden', 'true');
        if (window.getComputedStyle(bag).position === 'static') bag.style.position = 'relative';
        bag.appendChild(badge);
      }
      badge.textContent = n;
      badge.hidden = !(n > 0);
    }

    function paintCartCount(cart) {
      if (!cart) return;
      var n = cart.item_count;
      var landed = 0;
      var sel = [
        CFG.countSelector,
        '.cart-bubble__text',
        '.cart-count-bubble span[aria-hidden="true"]',
        '.cart-count-bubble span',
        '[data-cart-count]',
        '.cart-count',
        '.header__cart-count',
        '#cart-icon-bubble .cart-count-bubble span'
      ].filter(Boolean);

      sel.forEach(function (q) {
        var nodes;
        try { nodes = document.querySelectorAll(q); } catch (e) { return; }
        nodes.forEach(function (el) {
          if (el.closest && el.closest('#dpp-' + UID)) return;
          if (el.id === 'dpp-bagcount-' + UID) return;
          el.textContent = n;
          landed++;
        });
      });

      var bubble = document.querySelector('.cart-count-bubble');
      if (bubble && n > 0) bubble.removeAttribute('hidden');
      var hz = document.querySelector('.cart-bubble');
      if (hz && n > 0) hz.classList.remove('visually-hidden');

      if (landed === 0) ensureBadge(n);
      else {
        var mine = document.getElementById('dpp-bagcount-' + UID);
        if (mine) mine.hidden = true;
      }
    }

    function swapSections(sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (key) {
        if (/header/i.test(key)) return;
        var html = sections[key];
        var target = document.getElementById('shopify-section-' + key);
        if (!html || !target) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var srcEl = parsed.getElementById('shopify-section-' + key) || parsed.body;
        if (!srcEl) return;

        /* The cart drawer is a <dialog> built from custom elements that hold their own
           open state and listeners. Assigning innerHTML destroys and rebuilds every one
           of them, which made the drawer open blank after an add. Swap only the inner
           panel so <theme-drawer>, <dialog> and <cart-drawer-component> survive intact.
           Keyed on the hydration attribute rather than the section name so it holds up
           if the drawer section is ever renamed. */
        var liveInner = target.querySelector('[data-hydration-key="cart-drawer-inner"]');
        if (liveInner) {
          var freshInner = srcEl.querySelector('[data-hydration-key="cart-drawer-inner"]');
          if (freshInner) liveInner.replaceWith(freshInner);
          return;
        }

        target.innerHTML = srcEl.innerHTML;
      });
    }

    /* ---------- fly to the bag ---------- */
    function findBag() {
      var tries = [].concat(BAG_SELECTORS, ['[name="cart"]']);
      for (var i = 0; i < tries.length; i++) {
        var el;
        try { el = document.querySelector(tries[i]); } catch (e) { el = null; }
        if (el && el.getBoundingClientRect().width > 0) return el;
      }
      return null;
    }

    function flyToBag(fromEl) {
      if (!CFG.flyOn) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!mainImg || !fromEl) return;

      var target = findBag();
      var b;
      if (target) {
        b = target.getBoundingClientRect();
      } else {
        b = { left: window.innerWidth - 60, top: 20, width: 40, height: 40 };
      }

      var a = fromEl.getBoundingClientRect();
      var size = 46;

      var chip = document.createElement('div');
      chip.className = 'dpp-fly';
      chip.style.width = size + 'px';
      chip.style.height = size + 'px';
      chip.style.left = (a.left + a.width / 2 - size / 2) + 'px';
      chip.style.top = (a.top + a.height / 2 - size / 2) + 'px';
      var im = document.createElement('img');
      im.src = mainImg.currentSrc || mainImg.src;
      im.alt = '';
      chip.appendChild(im);
      document.body.appendChild(chip);

      var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
      var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
      var lift = Math.min(160, Math.abs(dy) * 0.45 + 60);

      var frames = [
        { transform: 'translate(0px, 0px) scale(1)', opacity: 1, offset: 0 },
        { transform: 'translate(' + (dx * 0.5) + 'px, ' + (dy * 0.5 - lift) + 'px) scale(.75)', opacity: 1, offset: 0.55 },
        { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(.2)', opacity: .25, offset: 1 }
      ];

      if (chip.animate) {
        var anim = chip.animate(frames, {
          duration: CFG.flyMs,
          easing: 'cubic-bezier(.5,-0.2,.6,1)',
          fill: 'forwards'
        });
        anim.onfinish = function () {
          chip.remove();
          if (target) {
            target.style.animation = 'dpp-bump .35s ease';
            setTimeout(function () { target.style.animation = ''; }, 400);
          }
        };
      } else {
        chip.remove();
      }
    }

    /* ---------- variant selection ---------- */
    var chosen = [];
    var initialVariant = variants.filter(function (vv) { return String(vv.id) === String(CFG.initialVariantId); })[0];
    if (initialVariant && initialVariant.options) {
      initialVariant.options.forEach(function (val, i) { chosen[i] = val; });
    }
    root.querySelectorAll('[data-dpp-opt]').forEach(function (btn) {
      var i = parseInt(btn.dataset.dppOpt, 10);
      if (btn.getAttribute('aria-pressed') === 'true') chosen[i] = btn.dataset.value;
      if (chosen[i] === undefined) chosen[i] = null;
    });

    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < chosen.length; j++) {
          if (chosen[j] === null || chosen[j] === undefined) continue;
          if (v.options[j] !== chosen[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function markUnavailable() {
      root.querySelectorAll('[data-dpp-opt]').forEach(function (btn) {
        var i = parseInt(btn.dataset.dppOpt, 10);
        var trial = chosen.slice();
        trial[i] = btn.dataset.value;
        var exists = variants.some(function (v) {
          for (var j = 0; j < trial.length; j++) {
            if (trial[j] === null || trial[j] === undefined) continue;
            if (v.options[j] !== trial[j]) return false;
          }
          return v.available;
        });
        btn.classList.toggle('dpp-is-gone', !exists);
      });
    }

    /* Used when something identifies a whole variant at once (a thumbnail photo,
       as opposed to a single swatch button), so every option row, not just one,
       ends up showing the right value. */
    function selectVariant(v) {
      if (!v || !v.options) return;
      for (var i = 0; i < v.options.length; i++) {
        chosen[i] = v.options[i];
        root.querySelectorAll('[data-dpp-opt="' + i + '"]').forEach(function (b) {
          b.setAttribute('aria-pressed', b.dataset.value === v.options[i] ? 'true' : 'false');
        });
        var label = root.querySelector('[data-dpp-optlabel="' + i + '"]');
        if (label) label.textContent = v.options[i];
      }
      markUnavailable();
      paint(v);
    }

    function paint(v) {
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = CFG.unavailable; }
        if (stickyAdd) stickyAdd.disabled = true;
        paintStageBadge(null);
        return;
      }
      paintStageBadge(v);
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (stickyPrice) {
        var cmp = stickyPrice.querySelector('[data-dpp-sticky-compare]');
        stickyPrice.textContent = money(v.price);
        if (cmp) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            cmp.textContent = money(v.compare_at_price);
            cmp.hidden = false;
          } else { cmp.hidden = true; }
          stickyPrice.appendChild(cmp);
        }
      }
      var stickySel = sticky ? sticky.querySelector('[data-dpp-sticky-variant]') : null;
      if (stickySel && String(stickySel.value) !== String(v.id)) stickySel.value = v.id;
      if (cartLoaded) refreshLimits();
      var stickyImg = sticky ? sticky.querySelector('[data-dpp-sticky-img]') : null;
      if (stickyImg && v.featured_image && v.featured_image.src) stickyImg.src = v.featured_image.src;

      if (wasEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          wasEl.textContent = money(v.compare_at_price);
          wasEl.hidden = false;
          if (saveEl) {
            saveEl.hidden = false;
            saveEl.textContent = CFG.savePrefix + ' ' +
              Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%';
          }
        } else {
          wasEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        }
      }

      if (skuEl) skuEl.textContent = v.sku || '';

      var weightEls = root.querySelectorAll('[data-dpp-weight]');
      if (weightEls.length) {
        var wtxt = '';
        if (exactWeights[v.id] !== undefined) {
          wtxt = exactWeights[v.id] + (v.weight_unit || 'g');
        } else if (v.weight > 0) {
          wtxt = v.weight + (v.weight_unit || 'g');
        }
        weightEls.forEach(function (el) { el.textContent = wtxt; });
      }
      if (CFG.colorOptionIndex >= 0) {
        var colorEls = root.querySelectorAll('[data-dpp-color]');
        if (colorEls.length) {
          var ctxt = (v.options && v.options[CFG.colorOptionIndex]) || '';
          colorEls.forEach(function (el) { el.textContent = ctxt; });
        }
        if (CFG.matchVariantColor) {
          var rawColor = (v.options && v.options[CFG.colorOptionIndex]) || '';
          var cssColor = rawColor.replace(/\s+/g, '').toLowerCase() || CFG.markerColor;
          var discGroup = root.querySelector('[data-dpp-fp-disc]');
          var discBody = root.querySelector('.dpp-fp-disc-body');
          if (discGroup) discGroup.style.color = cssColor;
          if (discBody) discBody.setAttribute('fill', cssColor);
        }
      }

      applyButtonState(v);

      if (stockText && stockDot) {
        stockDot.classList.remove('is-low', 'is-out');
        if (!v.available) {
          stockText.textContent = CFG.soldOut;
          stockDot.classList.add('is-out');
        } else if (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= CFG.lowAt) {
          stockText.textContent = CFG.lowStock.replace('[n]', v.inventory_quantity);
          stockDot.classList.add('is-low');
        } else {
          stockText.textContent = CFG.inStock;
        }
      }

      if (v.featured_media && mainImg && v.featured_media.preview_image) {
        mainImg.src = v.featured_media.preview_image.src;
        mainImg.removeAttribute('srcset');
      }
      if (v.featured_media && v.featured_media.id) {
        root.querySelectorAll('[data-dpp-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', String(b.dataset.mediaId) === String(v.featured_media.id) ? 'true' : 'false');
        });
      }

      if (window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }

    root.querySelectorAll('[data-dpp-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = parseInt(btn.dataset.dppOpt, 10);
        chosen[i] = btn.dataset.value;
        root.querySelectorAll('[data-dpp-opt="' + i + '"]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        var label = root.querySelector('[data-dpp-optlabel="' + i + '"]');
        if (label) label.textContent = btn.dataset.value;
        markUnavailable();
        paint(findVariant());
      });
    });
    markUnavailable();

    /* ---------- add to cart ---------- */
    function addToCart(sourceBtn) {
      var currentVariant = findVariant() || variants[0];
      if (!currentVariant || !currentVariant.available) {
        applyButtonState(currentVariant);
        return;
      }

      if (!idInput) return;
      idInput.value = currentVariant.id;

      var quantity = qty ? (parseInt(qty.value, 10) || 1) : 1;
      var remaining = remainingFor(currentVariant);

      if (remaining !== Infinity && (remaining <= 0 || quantity > remaining)) {
        refreshLimits();
        return;
      }

      var body = { id: currentVariant.id, quantity: quantity };

      var wanted = discoverCartSections().join(',');
      if (wanted) {
        body.sections = wanted;
        body.sections_url = window.location.pathname;
      }
      if (sourceBtn) sourceBtn.disabled = true;

      showError('');

      fetch((CFG.addUrl || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          return r.json().then(function (payload) {
            if (!r.ok) {
              var err = new Error(payload && payload.description ? payload.description : 'Could not add to cart');
              err.handled = true;
              err.payload = payload;
              throw err;
            }
            return payload;
          }).catch(function (e) {
            if (e.handled) throw e;
            var err2 = new Error('network');
            err2.handled = false;
            throw err2;
          });
        })
        .then(function (data) {
          flyToBag(sourceBtn || addBtn);
          if (sourceBtn) {
            sourceBtn.disabled = false;
            sourceBtn.classList.add('is-added');
            sourceBtn.textContent = CFG.addedLabel;
            setTimeout(function () {
              sourceBtn.classList.remove('is-added');
              applyButtonState(findVariant() || variants[0]);
            }, 1800);
          }
          var nativeBag = false;
          if (data && data.sections) {
            swapSections(data.sections);
            nativeBag = syncNativeBag(data.sections);
          }
          return fetch((CFG.cartUrl || '/cart') + '.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              inCart = {};
              (cart.items || []).forEach(function (li) { inCart[li.variant_id] = li.quantity; });
              refreshLimits();
              if (!nativeBag) paintCartCount(cart);
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, dppSelf: true } }));
              document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart, dppSelf: true } }));
            })
            .catch(function () {});
        })
        .catch(function (err) {
          if (sourceBtn) {
            sourceBtn.classList.remove('is-added');
            applyButtonState(findVariant() || variants[0]);
          }
          if (err && err.handled) {
            showError(err.message);
            loadCart();
          } else if (form) {
            form.submit();
          }
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        if (e.submitter && e.submitter.hasAttribute('name')) return; /* buy now goes to checkout */
        e.preventDefault();

        var currentVariant = findVariant() || variants[0];
        if (!currentVariant || !currentVariant.available) {
          applyButtonState(currentVariant);
          return;
        }

        addToCart(addBtn);
      });
    }
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        var currentVariant = findVariant() || variants[0];
        if (!currentVariant || !currentVariant.available) {
          applyButtonState(currentVariant);
          return;
        }
        addToCart(stickyAdd);
      });
    }

    /* ---------- sticky bar ---------- */
    if (sticky) {
      function setSticky(on) {
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      }

      if (CFG.stickyTrigger === 'always') {
        setSticky(true);
      } else if (CFG.stickyTrigger === 'scroll') {
        var onScroll = function () {
          setSticky(window.scrollY > CFG.stickyScroll);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      } else if (addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            setSticky(!entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        }, { threshold: 0 }).observe(addBtn);
      }

      var sVar = sticky.querySelector('[data-dpp-sticky-variant]');
      if (sVar) {
        sVar.addEventListener('change', function () {
          var picked = null;
          for (var i = 0; i < variants.length; i++) {
            if (String(variants[i].id) === String(sVar.value)) { picked = variants[i]; break; }
          }
          if (!picked) return;
          root.querySelectorAll('[data-dpp-opt]').forEach(function (b) {
            var oi = parseInt(b.dataset.dppOpt, 10);
            var isMine = picked.options[oi] === b.dataset.value;
            b.setAttribute('aria-pressed', isMine ? 'true' : 'false');
            if (isMine) {
              chosen[oi] = b.dataset.value;
              var label = root.querySelector('[data-dpp-optlabel="' + oi + '"]');
              if (label) label.textContent = b.dataset.value;
            }
          });
          paint(picked);
        });
      }
    }

    /* ---------- gallery keyboard and swipe ---------- */
    var thumbList = Array.prototype.slice.call(root.querySelectorAll('[data-dpp-thumb]'));
    if (thumbList.length > 1 && stage) {
      var gi = 0;
      function goTo(n) {
        gi = (n + thumbList.length) % thumbList.length;
        thumbList[gi].click();
      }
      thumbList.forEach(function (t, n) {
        t.addEventListener('click', function () { gi = n; });
      });
      stage.setAttribute('tabindex', '0');
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(gi - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(gi + 1); }
      });
      var touchX = null;
      stage.addEventListener('touchstart', function (e) {
        touchX = e.touches[0].clientX;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (touchX === null) return;
        var dx = e.changedTouches[0].clientX - touchX;
        if (Math.abs(dx) > 45) goTo(dx < 0 ? gi + 1 : gi - 1);
        touchX = null;
      });
    }

    /* ---------- accordion close buttons ---------- */
    root.querySelectorAll('.dpp-acc').forEach(function (acc) {
      var body = acc.querySelector('.dpp-acc-body');
      var sum = acc.querySelector('summary');
      if (!body || !sum) return;
      if (body.querySelector('.dpp-collapse')) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dpp-collapse';
      btn.setAttribute('aria-label', 'Collapse ' + (sum.textContent || '').trim());
      btn.innerHTML = 'Close<span aria-hidden="true">\u25B2</span>';

      btn.addEventListener('click', function () {
        acc.removeAttribute('open');
        var y = sum.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });

      body.appendChild(btn);
    });

    /* ---------- desktop auto-expand / mobile auto-collapse ---------- */
    (function () {
      /* ---------- measure the theme's pinned header ---------- */
      if (CFG.stickyHeaderAuto && CFG.stickyHeaderPx === 0) {
      (function () {
        var lastH = -1;
        var namedCache = [];

        function consider(n, acc) {
          if (!n || n === root || !n.getBoundingClientRect) return acc;
          if (root.contains(n) || n.contains(root)) return acc;
          if (n === document.body || n === document.documentElement) return acc;
          var cs = window.getComputedStyle(n);
          if (cs.position !== 'fixed' && cs.position !== 'sticky') return acc;
          if (cs.display === 'none' || cs.visibility === 'hidden') return acc;
          if (parseFloat(cs.opacity || '1') < 0.05) return acc;
          var r = n.getBoundingClientRect();
          /* Must be overlapping the very top of the viewport right now, and
             be a plausible header size, so chat widgets and bottom bars are
             not counted. */
          if (r.top > 2 || r.bottom <= 0) return acc;
          if (r.height < 8 || r.height > 300) return acc;
          return r.bottom > acc ? r.bottom : acc;
        }

        function refreshNamedCache() {
          /* Belt-and-braces list of likely header elements, for themes whose
             header sits just off the elementsFromPoint probe lines below.
             Re-querying the DOM for this is the relatively expensive part,
             so it is only refreshed occasionally (init/resize/settle), never
             every animation frame. */
          namedCache = Array.prototype.slice.call(
            document.querySelectorAll('header, sticky-header, [class*="header" i], [class*="announcement" i]')
          ).slice(0, 40);
        }

        function apply(h) {
          h = Math.round(h);
          if (h !== lastH) {
            lastH = h;
            root.style.setProperty('--dpp-header-h', h + 'px');
          }
          return h;
        }

        /* elementsFromPoint returns the whole stack at a coordinate,
           ancestors included, so however deeply the theme nests its header
           it still turns up. Probing three x positions because some themes
           only pin a centre logo bar or an edge-anchored utility bar. This
           is cheap enough to run every animation frame - see measureFast. */
        function probeStack() {
          var h = 0;
          var w = window.innerWidth || 1024;
          var xs = [Math.round(w / 2), 8, Math.max(8, w - 8)];
          for (var i = 0; i < xs.length; i++) {
            var stack = [];
            try { stack = document.elementsFromPoint(xs[i], 1) || []; } catch (e) { stack = []; }
            for (var j = 0; j < stack.length; j++) { h = consider(stack[j], h); }
          }
          return h;
        }

        function measureFull() {
          var h = probeStack();
          for (var k = 0; k < namedCache.length; k++) { h = consider(namedCache[k], h); }
          return apply(h);
        }

        /* A theme header that hides/shows on scroll (or slides in an
           announcement bar) typically animates that over 200-500ms. Polling
           only on scroll/resize events - even debounced to one check per
           frame - leaves a window where the last check landed mid-animation
           and nothing re-checks it once the events stop arriving, which is
           exactly the "fine most of the time, breaks when you scroll fast"
           symptom this used to have. Running the cheap probe on every single
           animation frame instead removes that window entirely: whatever
           the header is doing, --dpp-header-h is at most one frame stale. */
        var rafId = 0;
        function loop() {
          apply(probeStack());
          rafId = requestAnimationFrame(loop);
        }

        function scheduleFull() {
          refreshNamedCache();
          measureFull();
        }

        refreshNamedCache();
        measureFull();
        rafId = requestAnimationFrame(loop);
        window.addEventListener('resize', scheduleFull);
        window.addEventListener('load', scheduleFull);
        /* The continuous loop covers scrolling; this just catches DOM
           changes (an app embed injecting its own bar, etc.) that wouldn't
           otherwise trigger a namedCache refresh. */
        setInterval(refreshNamedCache, 2000);
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) { if (rafId) cancelAnimationFrame(rafId); rafId = 0; }
          else if (!rafId) { rafId = requestAnimationFrame(loop); }
        });
        window.__dppHeaderProbe = measureFull;
      })();
      }

      var ACC_D = CFG.accDesktopState;
      var ACC_M = CFG.accMobileState;
      var mql = window.matchMedia('(min-width: 750px)');
      var accSyncing = false;

      root.querySelectorAll('details.dpp-acc').forEach(function (d) {
        /* Remember the server-rendered state: a block with "Open by default"
           ticked is pinned open and ignores the section-level states. */
        if (!d.hasAttribute('data-dpp-acc-init')) {
          d.setAttribute('data-dpp-acc-init', d.open ? '1' : '0');
        }
        /* Once the visitor opens or closes one themselves, stop overriding it
           on resize or orientation change. */
        d.addEventListener('toggle', function () {
          if (!accSyncing) { d.dataset.dppAccTouched = '1'; }
        });
      });

      function syncAcc(e) {
        var want = e.matches ? ACC_D : ACC_M;
        accSyncing = true;
        root.querySelectorAll('details.dpp-acc').forEach(function (d) {
          if (d.dataset.dppAccTouched === '1') return;
          if (d.getAttribute('data-dpp-acc-init') === '1') { d.setAttribute('open', ''); return; }
          if (want === 'expanded') { d.setAttribute('open', ''); }
          else { d.removeAttribute('open'); }
        });
        accSyncing = false;
      }
      syncAcc(mql);
      if (mql.addEventListener) { mql.addEventListener('change', syncAcc); }
      else if (mql.addListener) { mql.addListener(syncAcc); }
    })();

    /* ---------- delivery estimate ---------- */
    root.querySelectorAll('[data-dpp-delivery]').forEach(function (el) {
      var daysMin = parseInt(el.dataset.min, 10) || 2;
      var daysMax = parseInt(el.dataset.max, 10) || 4;
      var cutoff = parseInt(el.dataset.cutoff, 10);
      if (isNaN(cutoff)) cutoff = 14;
      var countWeekends = el.dataset.weekend === 'true';
      var locale = el.dataset.locale || 'en';

      function addWorkingDays(from, days) {
        var d = new Date(from.getTime());
        var added = 0;
        while (added < days) {
          d.setDate(d.getDate() + 1);
          var day = d.getDay();
          if (countWeekends || (day !== 0 && day !== 6)) added++;
        }
        return d;
      }

      var now = new Date();
      var start = new Date(now.getTime());
      if (now.getHours() >= cutoff) start.setDate(start.getDate() + 1);

      var from = addWorkingDays(start, daysMin);
      var to = addWorkingDays(start, daysMax);

      var fmt = { weekday: 'short', month: 'short', day: 'numeric' };
      var text = from.toLocaleDateString(locale, fmt);
      if (to.getTime() !== from.getTime()) text += ' \u2013 ' + to.toLocaleDateString(locale, fmt);

      var out = el.querySelector('[data-dpp-delivery-date]');
      if (out) out.textContent = text;
    });

    /* ---------- share ---------- */
    root.querySelectorAll('[data-dpp-share]').forEach(function (el) {
      var url = el.dataset.url || window.location.href;
      var title = el.dataset.title || document.title;
      /* Web Share API opens the OS share sheet, which is the only route to
         apps like Instagram and TikTok that publish no share-a-link URL.
         Requires HTTPS and a real user gesture. Absent in desktop Firefox,
         so the button stays hidden there rather than failing on click. */
      if (navigator.share) {
        el.querySelectorAll('[data-dpp-share-native]').forEach(function (b) { b.hidden = false; });
      }
      el.querySelectorAll('[data-dpp-share-net]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var net = btn.dataset.dppShareNet;
          if (net === 'copy') {
            var done = el.querySelector('[data-dpp-copied]');
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(url).then(function () {
                if (done) { done.hidden = false; setTimeout(function () { done.hidden = true; }, 1800); }
              });
            }
            return;
          }
          var u = '';
          if (net === 'native') {
            if (!navigator.share) return;
            navigator.share({ title: title, url: url }).catch(function () { /* user dismissed */ });
            return;
          }
          var img = el.dataset.image || '';
          if (net === 'facebook') u = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
          if (net === 'x') u = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(title);
          if (net === 'pinterest') u = 'https://pinterest.com/pin/create/button/?url=' + encodeURIComponent(url) + '&media=' + encodeURIComponent(img) + '&description=' + encodeURIComponent(title);
          if (net === 'reddit') u = 'https://www.reddit.com/submit?url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(title);
          if (net === 'email') { window.location.href = 'mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(url); return; }
          if (u) window.open(u, 'share', 'width=600,height=480,noopener');
        });
      });
    });

    paint(findVariant() || variants[0]);
    loadCart();
    watchCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var B = window.__dppBound = window.__dppBound || {};
  if (!B[UID]) {
    B[UID] = true;
    document.addEventListener('shopify:section:load', function (e) {
      if (e.detail && e.detail.sectionId === UID) {
        var el = document.getElementById(ROOT_ID);
        if (el) el.dataset.dppReady = '0';
        init();
      }
    });
  }
};

(function () {
  var q = window.__dppQueue;
  if (q && q.length) {
    for (var i = 0; i < q.length; i++) { window.DppProductPro(q[i][0], q[i][1]); }
    window.__dppQueue = [];
  }
})();

/* Related-discs rows ("More options" / "More from this brand") can be set to
   shuffle their card order; the row's <ul> already carries data-dpp-shuffle
   and data-show (from the section markup, when that order mode is picked),
   so this scans for any such <ul> and applies to it directly - one shared
   routine instead of one inline <script> per matching block. */
(function () {
  function shuffleOne(ul) {
    if (ul.dataset.dppShuffled === '1') return;
    ul.dataset.dppShuffled = '1';
    var show = parseInt(ul.getAttribute('data-show'), 10) || 0;
    var items = Array.prototype.slice.call(ul.children);
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var swap = items[i]; items[i] = items[j]; items[j] = swap;
    }
    items.forEach(function (li, idx) {
      if (show && idx >= show) { li.parentNode.removeChild(li); return; }
      li.hidden = false;
      ul.appendChild(li);
    });
  }
  function shuffleAll() {
    var uls = document.querySelectorAll('[data-dpp-shuffle]');
    for (var i = 0; i < uls.length; i++) { shuffleOne(uls[i]); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', shuffleAll);
  } else {
    shuffleAll();
  }
  document.addEventListener('shopify:section:load', function () {
    var uls = document.querySelectorAll('[data-dpp-shuffle]:not([data-dpp-shuffled="1"])');
    for (var i = 0; i < uls.length; i++) { shuffleOne(uls[i]); }
  });
})();
